<div class="global-search-criteria">

  <div class="global-search-criteria-buttons">
    @if (hasClearFiltersButton()) {
      <app-tooltip [message]="globalClearFiltersTooltipMessage" [dynamic]="false">
        <button class="global-search-criteria-buttons-clear-filters-button"
          data-cy="global-search-criteria-buttons-clear-filters-button"
          (click)="globalSearchCriteriaClearHandler()">Clear filters
        </button>
      </app-tooltip>
    }
    <button class="global-search-criteria-buttons-apply-button btn-primary"
      data-cy="global-search-criteria-buttons-apply-button"
      (click)="submitSearchCriteria()"
    [disabled]="!hasCriteriaFiltersChipsInQueryArea()">Apply</button>
  </div>

  <div class="global-search-criteria-filters">

    <div class="global-search-criteria-filters-selection-area">
      <app-dropdown-criteria-selection
        [searchCriteriaChange]="dropdownSelectionChange"
        (dropdownIsOpenEvent)="emitDropdownIsOpen($event)"
        (searchCriteriaReset)="dropdownSearchCriteriaResetHandler()">
      </app-dropdown-criteria-selection>
    </div>

    <div class="global-search-criteria-filters-input-area">
      <app-input-criteria-type
        class="global-search-criteria-filters-input-type"
        [ngClass]="{'global-search-criteria-filters-input-type-hide': hideGlobalSearchFilterInput()}"
        [searchCriteriaChange]="inputCriteriaChange"
        [globalSearchCriteriaModel]="globalSearchCriteriaModel"
        (searchCriteriaReset)="inputCriteriaResetHandler()">
      </app-input-criteria-type>

      @if (showCriteriaFiltersChipsInQueryArea()) {
        <app-query-chips-area #chipsArea
          [ngClass]="{'global-search-criteria-filters-query-chips-wrapper-retract': hideGlobalSearchFilterInput()}"
          [retractChipsArea]="hideGlobalSearchFilterInput()"
        (removeChipEmitter)="openChipsArea($event)"></app-query-chips-area>
      }
    </div>

    <div class="global-search-criteria-query-chips-buttons-wrapper">
      <app-tooltip [dynamic]="false" [message]="queryChipsAreaClearTooltipMessage" placement="top">
        <button (click)="clearCriteriaFiltersChips()"
          [disabled]="!hasCriteriaFiltersChipsInQueryArea()"
          class="global-search-criteria-filters-clear-query-chips-button"
          data-cy="global-search-criteria-filters-clear-query-chips-button">
          <img class="global-search-criteria-filters-clear-query-chips-button-border"
            src="/assets/img/search/filter-delete.svg"/>
        </button>
      </app-tooltip>

      <div class="global-search-criteria-filters-expand-query-chips">
        <button [disabled]="disabledExpandButton"
          class="global-search-criteria-filters-expand-query-chips-button"
          data-cy="global-search-criteria-filters-expand-query-chips-button"
          (click)="expandCriteriaFiltersChips()">
          <span [ngClass]="{'iwp-icon-gen_arrow_down': !state.retractChipsAreaIconUp, 'iwp-icon-gen_arrow_up opened': state.retractChipsAreaIconUp}"
            class="global-search-criteria-filters-expand-query-chips-arrow"
          data-cy="global-search-criteria-filters-expand-query-chips-arrow"></span>
        </button>
      </div>
    </div>

  </div>
</div>
